import AiAnalysisResult from "./AiAnalysisResult";
import RelatedKeyword from "./RelatedKeyword";
import MeasurementResult from "./MeasurementResult";

export default function DetailLowerJawLine({data, img}) {
    return (
        <MeasurementResult type="아래 턱 라인" description='얼굴의 "아래턱 라인"은 턱 아래에 위치한 피부와 지방이 형성하는 라인을 가리킵니다. 이 라인은 턱 아래에서 목으로 이어지는 부분을 말하며, 얼굴의 형태와 윤곽을 결정짓는 중요한 부분 중 하나입니다. 아래턱 라인이 명확하고 선명하면 얼굴이 더욱 날렵하고 강렬하게 보일 수 있습니다.' 
        score={data.score}>
            <div className="row-wrap">
                <div className="img-wrap">
                    <div className="img-cont">
                        <img src={img.image_cross_polar_front} />

                        <div className="caption">2D</div>
                    </div>
                    {/* <div className="img-cont detail">
                        <div className="img">
                            <img src={process.env.PUBLIC_URL + "/image/img_report_result_detail_01.png"} />
                        </div>
                        <div className="img">
                            <img src={process.env.PUBLIC_URL + "/image/img_report_result_detail_01.png"} />
                        </div>
                    </div> */}
                </div>
                <section>
                    <p className="body3">
                        얼굴의 "아래턱 라인"은 턱 아래 피부와 지방이 형성하는 라인입니다. 이 부분은 얼굴의 윤곽을 결정짓는 중요한 요소입니다. 명확한 아래턱 라인은 얼굴을 날렵하게 보이게 합니다. 그러나 지방 증가나 피부 탄력 감소로 아래턱 라인이 흐려질 수 있습니다.
                    </p>
                </section>
            </div>

            <div className="row-wrap grow">
                <RelatedKeyword list={data.keyword} />

                <AiAnalysisResult 
                    text={data.aiResult} 
                />
            </div>
        </MeasurementResult>
    )
}